import React, { useEffect, useState, useCallback } from 'react';
import styled from 'styled-components';
import { useInventoryStore } from '../store/inventoryStore';
import CustomDropdown from './CustomDropdown';

const FiltersContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 24px;

  @media (min-width: 768px) {
    flex-direction: row;
    align-items: flex-end;
    flex-wrap: wrap;
    gap: 16px;
    row-gap: 16px;
  }
`;

const FilterContainer = styled.div`
  width: 100%;

  @media (min-width: 768px) {
    width: 160px;
    flex-shrink: 0;
  }
`;

const CompactDropdownWrapper = styled.div`
  /* Переопределяем стили дропдауна для более компактного вида */
  button {
    padding: 8px 12px !important;
    font-size: 14px !important;
    min-height: 40px !important;
  }
  
  label {
    font-size: 12px !important;
  }
`;

const ClearButton = styled.button`
  padding: 8px 16px;
  border-radius: 4px;
  border: 1px solid #FF6B6B;
  background-color: transparent;
  color: #FF6B6B;
  font-family: var(--font-family-main);
  font-weight: 500;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;
  min-height: 40px;
  align-self: flex-end;
  
  &:hover {
    background-color: #FF6B6B;
    color: #FFFFFF;
  }
`;

const SalesFilters: React.FC = () => {
  const {
    selectedBrandId,
    selectedModelId,
    selectedArticleId,
    selectedSize,
    availableBrandsWithId,
    availableModels,
    availableArticles,
    availableSizes,
    setSelectedBrandId,
    setSelectedModelId,
    setSelectedArticleId,
    setSelectedSize,
    clearFilters,
    fetchAllBrands,
    fetchAllModels,
    fetchAllArticles,
    salesItemsPerPage,
  } = useInventoryStore();

  const [isFirstRender, setIsFirstRender] = useState(true);

  // Загрузка данных для фильтров при монтировании
  useEffect(() => {
    fetchAllBrands();
    fetchAllModels();
    fetchAllArticles();
  }, []);

  // Применение фильтров при изменении (пропускаем первый рендер)
  useEffect(() => {
    if (isFirstRender) {
      setIsFirstRender(false);
      return;
    }

    const fetchData = async () => {
      await useInventoryStore.getState().fetchSales(0, salesItemsPerPage);
    };
    
    fetchData();
  }, [selectedBrandId, selectedModelId, selectedArticleId, selectedSize]);

  const handleClearFilters = useCallback(() => {
    clearFilters();
    setTimeout(() => {
      useInventoryStore.getState().fetchSales(0, salesItemsPerPage);
    }, 0);
  }, [clearFilters, salesItemsPerPage]);

  return (
    <FiltersContainer>
      <FilterContainer>
        <CompactDropdownWrapper>
          <CustomDropdown
            options={[{ value: '', label: 'Все бренды' }, ...availableBrandsWithId.map(b => ({ value: b.id.toString(), label: b.name }))]}
            value={selectedBrandId ? selectedBrandId.toString() : ''}
            onChange={val => setSelectedBrandId(val ? Number(val) : null)}
            label="Бренд"
          />
        </CompactDropdownWrapper>
      </FilterContainer>
      <FilterContainer>
        <CompactDropdownWrapper>
          <CustomDropdown
            options={[{ value: '', label: 'Все модели' }, ...(availableModels || []).map(m => ({ value: m, label: m }))]}
            value={selectedModelId || ''}
            onChange={val => setSelectedModelId(val || null)}
            label="Модель"
          />
        </CompactDropdownWrapper>
      </FilterContainer>
      <FilterContainer>
        <CompactDropdownWrapper>
          <CustomDropdown
            options={[{ value: '', label: 'Все артикулы' }, ...(availableArticles || []).map(a => ({ value: a, label: a }))]}
            value={selectedArticleId || ''}
            onChange={val => setSelectedArticleId(val || null)}
            label="Артикул"
          />
        </CompactDropdownWrapper>
      </FilterContainer>
      <FilterContainer>
        <CompactDropdownWrapper>
          <CustomDropdown
            options={[{ value: '', label: 'Все размеры' }, ...(availableSizes || []).map(s => ({ value: s, label: s }))]}
            value={selectedSize || ''}
            onChange={val => setSelectedSize(val || null)}
            label="Размер"
          />
        </CompactDropdownWrapper>
      </FilterContainer>
      <ClearButton onClick={handleClearFilters}>
        Сбросить
      </ClearButton>
    </FiltersContainer>
  );
};

export default SalesFilters;
